import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router';
import { router } from './app/Routes.tsx';
import { store, StoreContext } from './lib/stores/store.ts';
import { registerSW } from 'virtual:pwa-register';
import logger from './lib/helpers/logger.ts';
import { initUiScaling } from './lib/helpers/uiScaling.ts';

registerSW({
	onOfflineReady() {
		logger.debug.log('App ready to work offline');
	},
	onRegisteredSW(swUrl) {
		logger.debug.log('Service Worker registered:', swUrl);
	},
	onRegisterError(error) {
		logger.debug.error('Service Worker registration failed:', error);
	},
});

initUiScaling();

createRoot(document.getElementById('root')!).render(
	<StrictMode>
		<StoreContext.Provider value={store}>
			<RouterProvider router={router} />
		</StoreContext.Provider>
	</StrictMode>
);
